import { OrderFieldTypeEnum } from "Infrastructure/Api/Api";
import { createSelectOptions } from "Infrastructure/Utilities/Helpers/createSelectOptions";
import { OrderFieldOptionsModal } from "Settings/Modules/OrderSetup/Components/OrderFieldOptionsModal";
import FormSwitch from "Shared/Components/Form/CustomFormComponent/FormSwitch";
import Input from "Shared/Components/Form/CustomFormComponent/Input";
import Select from "Shared/Components/Form/CustomFormComponent/Select";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import Delete from "@mui/icons-material/Delete";
import DragIndicator from "@mui/icons-material/DragIndicator";
import { Box, Button, Stack } from "@mui/material";

export const SortableItem = ({
	id,
	index,
	remove,
	control,
	errors,
	watch,
	setValue,
	getValues,
	disabledUpdate,
}) => {
	const { attributes, listeners, setNodeRef, transform, transition } =
		useSortable({ id });

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
		display: "flex",
	};

	return (
		<Stack
			gap={{ xs: 1, md: 2 }}
			alignContent="flex-start"
			flexGrow={1}
			flexDirection={{ xs: "column", md: "row" }}
			justifyContent={{ md: "space-between" }}
			width="100%"
			ref={setNodeRef}
			style={style}
		>
			<Box
				{...attributes}
				{...listeners}
				sx={{
					cursor: disabledUpdate ? "auto" : "grab",
					opacity: disabledUpdate ? 0.5 : 1,
					flexShrink: 0,
					transition: "all 0.2s ease",
				}}
				alignSelf="flex-end"
			>
				<DragIndicator fontSize="small" />
			</Box>
			<Box width="100%">
				<Input
					id={`orderFields.${index}.key`}
					name={`orderFields.${index}.key`}
					control={control}
					label="Key"
					errors={errors}
					variant="outlined"
					disabled={disabledUpdate}
					inputChangeRegex={/[^a-z_]/g}
					fullWidth
				/>
			</Box>
			<Box width="100%">
				<Input
					id={`orderFields.${index}.label`}
					name={`orderFields.${index}.label`}
					control={control}
					label="Label"
					errors={errors}
					variant="outlined"
					disabled={disabledUpdate}
					fullWidth
				/>
			</Box>
			<Box width="100%">
				<Select
					id={`orderFields.${index}.type`}
					name={`orderFields.${index}.type`}
					control={control}
					label="Type"
					options={createSelectOptions(OrderFieldTypeEnum)}
					fullWidth
					variant={"outlined"}
					disabled={disabledUpdate}
					errors={errors}
				/>
			</Box>
			<Box width="100%">
				<Input
					id={`orderFields.${index}.emailLabel`}
					name={`orderFields.${index}.emailLabel`}
					control={control}
					label="Email Translation"
					errors={errors}
					variant="outlined"
					disabled={disabledUpdate}
					fullWidth
				/>
			</Box>
			<Box alignSelf="flex-end">
				<FormSwitch
					name={`orderFields.${index}.isEmailIncluded`}
					control={control}
					label="Enable in email"
					disabled={disabledUpdate}
				/>
			</Box>
			<Stack
				flexDirection="row"
				gap={1}
				justifyContent={{ md: "center" }}
				alignItems="flex-end"
			>
				{watch(`orderFields.${index}.type`) === OrderFieldTypeEnum.enum && (
					<OrderFieldOptionsModal
						onAccept={(val?: string) => {
							setValue(`orderFields.${index}.value`, val);
						}}
						values={getValues(`orderFields.${index}.value`) ?? undefined}
						formDisabled={false}
					/>
				)}
				<Box>
					<Button
						color="error"
						onClick={() => remove(index)}
						disabled={disabledUpdate}
						sx={{ flexGrow: 0.5 }}
						startIcon={<Delete />}
					>
						Remove
					</Button>
				</Box>
			</Stack>
		</Stack>
	);
};
